import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResearcherCertificate } from "../../../model/researcher-certificate";

@Component({
  selector: 'aw-create-researcher-certificate',
  templateUrl: './create-researcher-certificate-dialog.component.html',
  styleUrls: ['./create-researcher-certificate-dialog.component.scss']
})
export class CreateResearcherCertificateDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ResearcherCertificate,
    public dialogRef: MatDialogRef<CreateResearcherCertificateDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


